import { render, staticRenderFns } from "./informationForm.vue?vue&type=template&id=270a64ed&"
import script from "./informationForm.vue?vue&type=script&lang=ts&"
export * from "./informationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports